export default {
    sections: ['details', 'permissions'],
    toolbar: ['edit'],
    fields: {
        name: {
            section: 'details',
            position: 0,
        },
        description: {
            section: 'details',
            position: 1,
        },
        permissions: {
            component: 'multi-select-array',
            section: 'permissions',
            position: 0,
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.role.js